module.exports = __webpack_public_path__ + "img/main03.e2122bcc.jpg";